/**
 * These values are used for analytics purpose to determine, where the component is rendering.
 */
export const WhoCalledRatingPerformanceModal = {
  /**
   * If the component is rendered, when we are calling it from shift-details screen, select this value.
   */
  SHIFT_DETAILS: "shiftDetails",
  /**
   * If the component is rendered, when we are calling it from chat channel screen, set this value.
   */
  CHAT_CHANNEL: "chatChannel",
  /**
   * This property is used, in case when the rating performance modal is opened from worker details page.
   */
  WORKER_DETAILS: "workerDetails",
  /**
   * If the component is rendered, when we are calling it from workers screen, set this value.
   */
  WORKERS_PAGE: "workersPage",
  /**
   * If the component is rendered, when we are calling it from workers carousel, set this value.
   */
  WORKER_RATINGS_CAROUSEL: "workerRatingsCarousel",
  /**
   * If the component is rendered, when we are calling it from high rating worker details page, set this value.
   */
  HIGH_RATING_WORKER_PAGE: "highRatingWorkerPage",
  /**
   * If the component is rendered, when we are calling it from my professionals page, set this value.
   */
  MY_PROFESSIONALS: "myProfessionals",
  /**
   * If the component is rendered, when we are calling it from exclusion candidates banner, set this value.
   */
  EXCLUSION_CANDIDATES_BANNER: "exclusionCandidatesBanner",
} as const;
